<template>
    <div class="fx-h5">
        <slot></slot>
    </div>
</template>
  
<script lang="ts">
  export default {
    name: 'FxH5',
  };
</script>
<script setup lang="ts">
  const props = defineProps({
    title: String,
  });
</script>
  
<style lang="less">
  .fx-h5{
    position:fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
  